import { Constants } from '../../const/globals';

const isFeatureValid = (featureName, testOperator, testValue, license) => {
  let result = false;
  const licenseFeatureValue = license[featureName];

  switch (testOperator) {
    case '=':
      result = licenseFeatureValue === testValue;
      break;
    case '<':
      result = licenseFeatureValue < testValue;
      break;
    case '>':
      result = licenseFeatureValue > testValue;
      break;
    default:
    // todo implement || (OR) operator
  }
  return result;
};

const isTierValid = (ruleTierName, license) => {
  let result = false;
  const { tierName: licenseTierName = 'Free' } = license;
  const availableTiers = Constants.TIERS.TIER_LIST;
  const ruleTierIndex = availableTiers.indexOf(ruleTierName);
  const licenseTierIndex = availableTiers.indexOf(licenseTierName);
  if (licenseTierIndex >= ruleTierIndex && ruleTierIndex !== -1) {
    result = true;
  }
  return result;
};

const isRuleListInLicenseList = (featureName, rueValues, license) => {
  if (!featureName || !license[featureName] || typeof license[featureName] !== 'string') {
    return false;
  }
  const licenseValues = license[featureName].split(',');
  const result = licenseValues.some(licenseValue => rueValues.includes(licenseValue));
  return result;
};

const isRuleListNotInLicenseList = (featureName, rueValues, license) => {
  if (!featureName || !license[featureName] || typeof license[featureName] !== 'string') {
    return false;
  }
  const licenseValues = license[featureName].split(',');
  const result = !licenseValues.some(licenseValue => rueValues.includes(licenseValue));
  return result;
};

const licenseValidators = (rules, license) => {
  if (!rules || !Array.isArray(rules) || rules.length === 0) {
    return false;
  }
  if (!license || !(Object.prototype.toString.call(license) === '[object Object]')) {
    return false;
  }

  const allRulesResults = [];
  rules.forEach(rule => {
    const ruleResults = [];
    Object.entries(rule).forEach(ruleEntry => {
      switch (ruleEntry[0]) {
        case 'tierName': {
          ruleResults.push(isTierValid(ruleEntry[1], license));
          break;
        }
        case 'productFeatures':
        case 'addonFeatures':
          ruleResults.push(isRuleListInLicenseList(ruleEntry[0], ruleEntry[1], license));
          break;
        default:
          ruleResults.push(isFeatureValid(ruleEntry[0], ruleEntry[1][0], ruleEntry[1][1], license));
      }
    });
    allRulesResults.push(ruleResults.includes(true)); // implicit or
  });
  return !allRulesResults.includes(false); // implicit and
};

export { licenseValidators, isRuleListNotInLicenseList };
